export { default as Math } from './math';
